// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import Header from "./header";
// import { Box, Card, Drawer, Typography } from "@mui/material";
// import SoftBox from "components/SoftBox";
// import SoftButton from "components/SoftButton";
// import PrePayment from "./PrePayment";
// import Payroll from "./Payroll";
// import Expenses from "./Expenses";
// import Incentive from "./Incentive";
// import MainHeader from "./mainheader";
// import SalaryTeam from "./SalaryTeam";
// import PrePaymentTable from "./PrePayment/PrepaymentTable";
// import { useLocation } from "react-router-dom";
// import TeamList from "layouts/home/tlist";

// function SalaryComponents() {
//   const { userId } = useParams(); //  Get userId from route
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [activeTopTab, setActiveTopTab] = useState("My Data");
//   const [activeDataTab, setActiveDataTab] = useState("Pre Payment");


//   const location = useLocation(); // 👈 Get state from navigation
// const { tab, dataTab } = location.state || {}; // fallback if undefined

// useEffect(() => {
//   if (userId) {
//     setSelectedUser(userId);
//     setActiveTopTab(tab || "My Data"); // set from state or fallback
//     setActiveDataTab(dataTab || "Pre Payment");
//   }
// }, [userId, tab, dataTab]);



//   //  Optional: simulate user loading from ID
//   // const [selectedUser, setSelectedUser] = useState(null);

//   // useEffect(() => {
//   //   if (userId) {
//   //     // Load or simulate user (could be API call)
//   //     setSelectedUser(userId);
//   //     setActiveTopTab("My Data");
//   //     setActiveDataTab("Pre Payment");
//   //   }
//   // }, [userId]);

//   return (
//     <DashboardLayout>
//       <MainHeader
//         activeTopTab={activeTopTab}
//         setActiveTopTab={setActiveTopTab}
//         activeDataTab={activeDataTab}
//         setActiveDataTab={setActiveDataTab}
//       />

//       {/* Optionally show user ID or profile */}
//       {userId && (
//         <Box pl={3} pb={1}>
//           <Typography variant="caption" color="text">
//             Viewing Salary Info for User ID: <strong>{userId}</strong>
//           </Typography>
//         </Box>
//       )}

//       {activeTopTab === "My Data" && (
//         <>
//           {activeDataTab === "Pre Payment" && (
//             <Card sx={{ pt: 4, pb: 15, pl: 4, borderRadius: 3, height: 650, width: "100%" }}>
//               <Box>
//                 <SoftButton variant="gradient" color="info" size="small" sx={{ mt: 3, ml: 3 }} onClick={() => setDrawerOpen(true)}>
//                   Generate Pre Payment
//                 </SoftButton>
//               </Box>
//               <Drawer
//                 anchor="right"
//                 open={drawerOpen}
//                 onClose={() => setDrawerOpen(false)}
//                 PaperProps={{ sx: { width: 850, maxWidth: 1200 } }}
//               >
//                 <Box p={3} width="850px">
//                   <PrePayment handleClose={() => setDrawerOpen(false)} />
//                 </Box>
//               </Drawer>
//               <PrePaymentTable />
//             </Card>
//           )}

//           {activeDataTab === "Payroll" && <Payroll />}
//           {activeDataTab === "Expenses" && <Expenses />}
//           {activeDataTab === "Incentive" && (
//             <Card sx={{ pt: 4, pb: 15, pl: 4, borderRadius: 3, height: 650, width: "100%" }}>
//               <Box>
//                 <SoftButton variant="gradient" color="info" size="small" sx={{ ml: 5, mt: 5 }} onClick={() => setDrawerOpen(true)}>
//                   Add Incentive
//                 </SoftButton>
//               </Box>
//               <Drawer
//                 anchor="right"
//                 open={drawerOpen}
//                 onClose={() => setDrawerOpen(false)}
//                 PaperProps={{ sx: { width: 850, maxWidth: 1200 } }}
//               >
//                 <Box p={3} width="850px">
//                   <Incentive handleClose={() => setDrawerOpen(false)} />
//                 </Box>
//               </Drawer>
//               <PrePaymentTable />
//             </Card>
//           )}

//           {activeDataTab === "Other" && (
//             <Box
//               display="flex"
//               flexDirection="column"
//               justifyContent="center"
//               alignItems="center"
//               width="100%"
//               height={600}
//               borderRadius="10px"
//               bgcolor="#ffffff"
//               boxShadow="0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)"
//             >
//               <Typography variant="body2" color="textSecondary">
//                 No Data Found
//               </Typography>
//             </Box>
//           )}
//         </>
//       )}

//       {activeTopTab === "Team" && <SalaryTeam />}
//     </DashboardLayout>
//   );
// }

// export default SalaryComponents;


// In your SalaryComponents.js
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Header from "./header";
import { Box, Card, Drawer, Typography } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import PrePayment from "./PrePayment";
import Payroll from "./Payroll";
import Expenses from "./Expenses";
import Incentive from "./Incentive";
import MainHeader from "./mainheader";
import SalaryTeam from "./SalaryTeam";
import PrePaymentTable from "./PrePayment/PrepaymentTable";
import { useLocation } from "react-router-dom";
import TeamList from "layouts/home/tlist";
import SalaryManual from "./SalaryManual";

function SalaryComponents() {
  const { userId } = useParams();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeTopTab, setActiveTopTab] = useState("My Data");
  const [activeDataTab, setActiveDataTab] = useState("Pre Payment");

  const location = useLocation();
  const { tab, dataTab } = location.state || {};

  useEffect(() => {
    if (userId) {
      setSelectedUser(userId);
      setActiveTopTab(tab || "My Data");
      setActiveDataTab(dataTab || "Pre Payment");
    }
  }, [userId, tab, dataTab]);

  return (
    <DashboardLayout>
      {/* Update MainHeader to include the new tab */}
      <MainHeader
        activeTopTab={activeTopTab}
        setActiveTopTab={setActiveTopTab}
        activeDataTab={activeDataTab}
        setActiveDataTab={setActiveDataTab}
        tabs={["My Data", "Team", "Salary Manual"]} // Add the new tab
      />

      {userId && (
        <Box pl={3} pb={1}>
          <Typography variant="caption" color="text">
            Viewing Salary Info for User ID: <strong>{userId}</strong>
          </Typography>
        </Box>
      )}

      {activeTopTab === "My Data" && (
        <>
          {activeDataTab === "Pre Payment" && (
            <Card sx={{ pt: 4, pb: 15, pl: 4, borderRadius: 3, height: 650, width: "100%" }}>
              <Box>
                <SoftButton variant="gradient" color="info" size="small" sx={{ mt: 3, ml: 3 }} onClick={() => setDrawerOpen(true)}>
                  Generate Pre Payment
                </SoftButton>
              </Box>
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                PaperProps={{ sx: { width: 850, maxWidth: 1200 } }}
              >
                <Box p={3} width="850px">
                  <PrePayment handleClose={() => setDrawerOpen(false)} />
                </Box>
              </Drawer>
              <PrePaymentTable />
            </Card>
          )}

          {activeDataTab === "Payroll" && <Payroll />}
          {activeDataTab === "Expenses" && <Expenses />}
          {activeDataTab === "Incentive" && (
            <Card sx={{ pt: 4, pb: 15, pl: 4, borderRadius: 3, height: 650, width: "100%" }}>
              <Box>
                <SoftButton variant="gradient" color="info" size="small" sx={{ ml: 5, mt: 5 }} onClick={() => setDrawerOpen(true)}>
                  Add Incentive
                </SoftButton>
              </Box>
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                PaperProps={{ sx: { width: 850, maxWidth: 1200 } }}
              >
                <Box p={3} width="850px">
                  <Incentive handleClose={() => setDrawerOpen(false)} />
                </Box>
              </Drawer>
              <PrePaymentTable />
            </Card>
          )}

          {activeDataTab === "Other" && (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              width="100%"
              height={600}
              borderRadius="10px"
              bgcolor="#ffffff"
              boxShadow="0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)"
            >
              <Typography variant="body2" color="textSecondary">
                No Data Found
              </Typography>
            </Box>
          )}
        </>
      )}

      {activeTopTab === "Team" && <SalaryTeam />}
      
      {/* Add the new Salary Manual tab */}
      {activeTopTab === "Salary Manual" && <SalaryManual />}
    </DashboardLayout>
  );
}

export default SalaryComponents;
